import React from 'react';
import { ModalContainer, StyledImage, StyledVideo } from './PreviewAlbumMediaModal.styles';
import BaseModal from '../utils/BaseModal/BaseModal';
import { ALBUM_MEDIA_TYPE } from '../../../utils/constants';

const PreviewAlbumMediaModal = ({ modalRef, type, url, setSelectedUrl }) => {
  return (
    <BaseModal
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
      }}
      increasedWidth
      onAfterClose={() => setSelectedUrl(null)}
      shouldCloseOnOverlayClick>
      <ModalContainer>
        {type === ALBUM_MEDIA_TYPE.PHOTO ? (
          <StyledImage src={url} alt="premium-photo-media" onClick={() => {}} />
        ) : (
          <StyledVideo controls src={url} onClick={() => {}} />
        )}
      </ModalContainer>
    </BaseModal>
  );
};

export default PreviewAlbumMediaModal;
